import { Component, OnInit, Input, Injector, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { CommonService } from 'src/modules/base/services/common.service';
import { DynamicPopUpComponent } from 'src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { take } from 'rxjs';
// import { EventEmitter } from 'stream';

@Component({
  selector: 'app-orders-card-view',
  templateUrl: './orders-card-view.component.html',
  styleUrls: ['./orders-card-view.component.scss'],
  standalone: false
})
export class OrdersCardViewComponent extends MainComponent implements OnInit {
  @Input() item: any;
  @Input() card_resource: any;
  @Input() rowClick: any;
  @Input() index: any;
  @Output() action = new EventEmitter<any>();
  ambulanceData: any;
  ambulanceStatus: any;
  imageURL = '';
  userType: any;
  viewMap: boolean = false;
  resourceDef: any;
  header: any;
  body: any;
  footer: any;
  headerResource: any;
  bodyResource: any;
  footerResource: any
  showIcon: boolean = false
  profileData: any
  buttonResource: any;
  resource: any;
  config: any = {};
  SubHeader: any;
  wrapperStyle: any = {};
  visibleButtons: any;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    private commonService?: CommonService,
  ) {
    super(injector, route);
  }

  ngOnInit() {
    // console.log("this.item", this.item);
    this.baseService.getResourceDef(this.card_resource, (data) => {
      if (this["uiConfigData"] != undefined) {
        var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: data }, this["uiConfigData"]);
        if (afterConfig.resouceDef != undefined) {
          data = afterConfig.resouceDef;
        }
      }

      this.resource = data
      this.resourceDef = data.card.blocks;

      this.init();

    })

  }

  init(callback: any = false) {
    this.setFields(this.resourceDef)

    this.userType = this.authenticationService.getUserType();
    if (this.userType == 'patient' && this.item.participant_details)
      this.getProfileData(this.item.participant_details[0].participantId)
    else if (this.userType !== 'patient' && this.item.patient_id)
      this.getPatientProfile(this.item.uhId == undefined ? this.item.preRegistrationNo : this.item.uhId)

    if (this.item.serviceType_code === 'ambulance') {
      this.getData(this.item)
    }

    if (callback) {
      callback()
    }
  }

  rowClickEmit() {
    let datatosend = { item: this.item, index: this.index };
    this.action.emit(datatosend);
  }

  checkBannerExpression(expression, item): boolean {
    let flag = true;
    try {
      if (expression != undefined) {
        flag = eval(expression);
      }
    } catch (error) { }
    return flag;
  }

  getData(item) {
    this.baseService.get('GET_PAGE', '', 'ambulance_approve', 'ambulance-management', 'orderId:' + item.orderId).subscribe(resp => {
      this.ambulanceData = resp.resource[0];
      if (this.ambulanceData && this.ambulanceData.stage) {
        this.baseService.getResourceDef('ambulance_status', (data) => {
          this.ambulanceStatus = data.status_color.find(element => (element.stage == this.ambulanceData.stage));
        })
      }
    })
  }

  getPatientProfile(profileId?: any) {
    let args = "uhId:" + profileId;
    this.baseService.get("GET_PATIENT_PROFILE_BY_UHID", args, "patient", "patient-registration").subscribe((data: any) => {
      if (data) {
        if (data.resource.length > 0 && data.resource[0].extra_data.path && data.errCode !== -1) {
          this.imageURL = data.resource[0].extra_data.path
        } else {
          this.imageURL = "";
        }
      }
    })
  }

  getProfileData(doctor_id?) {
    let args = 'doctor_id:' + doctor_id

    this.baseService.get("GET_DOCTOR_PROFILE_ID", args, "practitioner_facility_details", 'facility-management').subscribe(
      (data: any) => {
        if (data.resource != undefined && data.resource.length > 0 && data.resource[0].extra_data.path && data.errCode !== -1) {
          this.imageURL = data.resource[0].extra_data.path
        }
        else {
          this.imageURL = "";
        }
        // console.log('image url....', this.imageURL);

      }
    );
  }

  checkCondition(item: any) {
    if (item.stage == 'Started' && item.serviceItemCode == 'video') {
      return true
    } else {
      return false
    }
  }

  trackAmbulance() {
    this.viewMap = !this.viewMap
  }

  buttonAction(button, item) {
    let decorator_instance = this.baseService.initDecorator(button.decorator, this.route, this.injector);
    let decorator_data = { actionType: button, _currentData: item, data: item }
    const handleCapabilityClick = (val) => {
      if (val) {
        if (button.action == 'trackAmbulance' && this.ambulanceData)
          this.trackAmbulance();
        else if (button.action == 'payNow')
          this.payNow(button, item)
        else if (button.action.toLowerCase() == 'videocall')
          this.openVideoCall(button, item)
        else if (button.action.toLowerCase() == 'confirm')
          this.confirmBoxResource(item, button)
        else if (button.action.toLowerCase() == 'direct_request')
          this.confirmResource(item, button);
        else if (button.action.toLowerCase() == 'popup_form')
          this.popupForm(button, item);
        else if (button.action.toLowerCase() == 'custom')
          this.customRoute(button, item);
      }
    }
    if (decorator_instance && typeof decorator_instance.capabilityClick == 'function') {
      decorator_instance.capabilityClick(decorator_data, handleCapabilityClick);
    }
    else {
      handleCapabilityClick(true);
    }
  }

  confirmBoxResource(data, action) {
    if (this.dialogRef)
      this.dialogRef.close();
    let popupTitle = "";
    this.translateService.translate(action.label ? action.label : action.title).subscribe(x => {
      if (x) {
        popupTitle = x;
      }
    });
    let name: string = "";
    if (action.name != undefined) {
      name = data[action.name];
    } else {
      name = "";
    }
    const dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        this.loader.showSpinner();
        if (action.datasource.data != undefined) {
          var res = action.datasource.data[0];
          for (let i = 0; i < Object.keys(res).length; i++) {
            data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
          }
          this.confirmResource(data, action);
        } else if (action.datasource.url != undefined) {
          var url = this.baseService.buildDyanamicStr(action.datasource.url, { data: data });
          let i = document.createElement('iframe');
          i.src = url
          i.width = "1";
          i.height = "1";
          var r = document.querySelector('body').appendChild(i);
          setTimeout(() => {
            r.hidden = true
          }, 100)

          this.loader.hideSpinner();
        } else {
          this.confirmResource(data, action);
        }
      }
    },
      () => { });
  }

  confirmResource(item, action) {
    this.baseService.action(item, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
      (data: any) => {
        this.communicationService.emitChange({ completed: true });
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          this.alerts.success("Updated Successfully");
          if (action.show_message) {
            this.alerts.successWithMessage("", this.baseService.buildDyanamicStr(action.show_message, { data: data.resource[0] }))
          }
          // this.init()
          this.bindDataFn(item, action);
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      });
  }

  bindDataFn(item, action) {
    let queryParms = { key: item.id }; let action_value = { returnUrl: this.router.url }
    if (action && action.queryParams) {
      action_value['banner'] = JSON.stringify(action.queryParams)
    }
    queryParms = { ...queryParms, ...action_value }
    if (action && action.required_rowData != undefined && action.required_rowData) {
      sessionStorage.setItem('currentData', JSON.stringify(item));
    }
    this.router.navigate([action.redirectLink], { queryParams: queryParms })
  }

  checkConditionactionname(data) {
    // debugger;
    if (data.hasOwnProperty('check_permission')) {
      if (data.check_permission) {
        return this.rolePermissionService.checkAccessPermission(data.action_name, this.resource.resource, data.resource_application)
      }
      else {
        return data.check_permission
      }
    } else if (data.hasOwnProperty('action_name')) {
      return this.rolePermissionService.checkAccessPermission(data.action_name, this.resource.resource, data.resource_application)
    } else {
      return true
    }
  }

  openVideoCall(action, key) {
    var teleService = this.baseService.getTeleService();
    if (teleService != undefined) {
      //key_to_send, key_to_show needs to be removed
      // url = '/' + action['action_name'] + '/' + action['application']
      teleService.initCallData(this.getTelemedicine(key, action, "key_to_send"), this.getTelemedicine(key, action, "key_to_show"), this.getTelemedicine(key, action, "channel_id"), this.getTelemedicine(key, action, "order_id"), action, key, () => {
        // if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
        //   this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
        // } else {
        //   this.bindGrid();
        // }
      });
    }
  }

  // profileFn(index, item) {
  //   return item.id
  // }

  // resourceFn(index, item) {
  //   return item.id;
  // }

  // buttonResourceFn(index, item) {
  //   return item.id
  // }

  getTelemedicine(item, hasJson, key: any) {
    if (hasJson[key].split("=>")[0].replace(/\s+/g, ' ').trim() == "(item)") {
      return eval(hasJson[key])(item)
    } else {
      return item[hasJson[key]]
    }
  }

  payNow(button: any, item: any) {
    if (button.hasOwnProperty("required_rowData")) {
      this.storageService.setSessionStorageData('currentData', item, () => { console.log("saved") })
    }
    this.storageService.setSessionStorageData("facility_id", item.facility_id, () => { console.log("saved") })
    console.log("button .key is :: ", button.key)
    if (button.route_path != undefined && button.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(button.route_path, item);
    } else {
      var url = ""
      this.router.navigate([button.resource_application + "/" + item[button.key] + "/" + button.resource + "/" + button.type], {
        queryParams: {
          key: item.id, returnUrl: window.location.pathname
        }
      })
    }
  }


  getValue(item: any, field: any) {
    var format = field.format;
    let ageConfig = localStorage.getItem("ageConfig");
    if (field.checkConfig && ageConfig && Number(ageConfig) > 0) {
      field.checkConfigKey = field.checkConfigKey ? field.checkConfigKey : 'patient_age';
      let val = item[field.checkConfigKey];
      if (val) {
        let valD = val.split(" ");
        if (valD[0] > Number(ageConfig) && valD[1].includes("Y")) {
          item[field.checkConfigKey] = valD[0] + " Y";
        }
      }
    }
    if (field.type === 'array') {
      let val = [];
      if (item[field.name] && item[field.name] != undefined) {
        let arrayItem = item[field.name][0];
        let e = eval(format)(arrayItem);
        val.push(e);
      }
      return val;
    }
    if (field.type === 'advanceText') {
      if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
        return item[field.name];
      }
    }
    if (field.type === 'composite' && (field.class == "_card-sub-heading" || field.class_conditions)) {
      try {
        if (item)
          return eval(format)(item);
        else
          return '';
      } catch (e) {
        ;
        return ''
      }
    }
    if (field.type === 'composite' && field.format) {
      let val = [];
      const source = field.name ? item[field.name] : item;
      if (source !== undefined) {
        try {
          const formatFn = eval(field.format) as (x: any) => string;
          let e = formatFn(source);
          if (e === undefined || e === null) {
            e = "";
            if (field.icon) this.showIcon = true;
          }
          val.push(e);
        } catch (err) {
          console.error("Format evaluation failed:", err);
          val.push("");
        }
      } else if (field.type === 'composite' && field.format && field.name) {
        const formatFn = eval(field.format);
        val = formatFn(item);
      }
      return val;
    }


    if ((field.type === 'combinationDatetime') && field.format) {
      let val: string[] = [];
      try {
        const formatFn = eval(field.format) as (x: any) => string;
        const source = field.name && field.name.includes(",") ? field.name.split(",").reduce((acc: any, key: string) => { acc[key.trim()] = item[key.trim()]; return acc; }, {}) : field.name ? item[field.name] : item;
        let e = formatFn(source);
        // if datetime, format slotStartTime properly
        if (field.type === "combinationDatetime" && Object.values(source)[0]) {
          const rawValue = Object.values(source)[0] as number; // since it's a timestamp
          const formattedDateTime = this.utilService.toTimeZoneDateFormat(rawValue, 'datetime');
          e = e.replace(String(rawValue), formattedDateTime);
        }

        if (!e) {
          e = "";
          if (field.icon) this.showIcon = true;
        }
        val.push(e);
      } catch (err) {
        console.error("Format evaluation failed:", err);
        val.push("");
      }
      return val;
    }

    if (!field.type) {
      let val = [];
      if (item[field.name] != undefined) {
        let e = item[field.name] === 'undefined' ? "" : item[field.name]
        val.push(e);
      }
      return val;
    }
  }

  setFields(resourceDef) {
    this.header = resourceDef.header;
    this.body = resourceDef.body;
    this.footer = resourceDef.footer
    this.footerResource = this.resourceDef.footer;
    if (this.header) {
      this.headerResource = this.validConditions(resourceDef.header.fields);
      this.profileData = this.validConditions(resourceDef.header.profile);
      if (resourceDef?.sub_header?.fields) {
        this.SubHeader = this.validConditions(resourceDef?.sub_header?.fields);
      }
    }

    if (this.footer.actions.buttons) {
      this.footer.actions.buttons.sort((a, b) => { return a.order - b.order }); //sorting applied on buttons
      this.buttonResource = this.validConditions(this.footer.actions.buttons)
      this.getButtonCount(this.buttonResource)
    }

    if (this.appService.getAppData().AUTO_COLUMNS != undefined && this.appService.getAppData().AUTO_COLUMNS.length > 0) {
      for (let index = 0; index < this.appService.getAppData().AUTO_COLUMNS.length; index++) {
        var singleAuto = this.appService.getAppData().AUTO_COLUMNS[index];
        if ((singleAuto["config_key"] != undefined && this.resource.config != undefined && this.resource.config[singleAuto["config_key"]] != undefined && this.resource.config[singleAuto["config_key"]].auto_column != undefined && this.resource.config[singleAuto["config_key"]].auto_column == true) && ((singleAuto["universal_config_enabled"] && singleAuto["universal_config_key"] != undefined && (this.appService.getUniversalConfig(singleAuto["universal_config_key"]))) || singleAuto["universal_config_enabled"] == false)) {
          resourceDef.body = resourceDef.body == undefined ? [] : resourceDef.body;
          resourceDef.body.fields = resourceDef.body.fields == undefined ? [] : resourceDef.body.fields;
          resourceDef.body.fields = resourceDef.body.fields.concat([singleAuto]);
          this.resource.auto_column[singleAuto["config_key"]] = true;
        }
      }
    }

    if (this.resource.config && (this.resource.config.taggable == undefined || this.resource.config.taggable == true) && !this.resource.card.blocks.body.fields.find(x => x.heading != undefined && x.heading == "field.label.tag" && x.name != undefined && x.name == "tag_data" && x.type != undefined && x.type == 'HashMap')) {
      this.resource.card.blocks.body.fields = this.resource.card.blocks.body.fields.concat({
        "heading": "field.label.tag",
        "card_tag": null,
        "type": "HashMap",
        "name": "tag_data"
      })
    }

    if (this.body)
      this.bodyResource = this.validConditions(resourceDef.body.fields);

  }

  validConditions(fields) {
    fields.forEach(field => {
      if (field.conditions && field.conditions.length > 0) {
        if (field.name == 'uhId' && this.item[field.name] != undefined) {
          field['class_name'] = field['class_name'] ? field['class_name'] + " uhid-pill" : "uhid-pill"
        }
        let valid = this.isExpressionValid(field.conditions);
        if (valid == -1)
          field['valid'] = true
        else
          field['valid'] = false
      }
      else {
        if (field.name == 'uhId' && this.item[field.name] != undefined) {
          field['class_name'] = field['class_name'] ? field['class_name'] + " uhid-pill" : "uhid-pill"
        }
        field['valid'] = true
      }
    })

    return fields
  }

  isExpressionValid(conditions) {
    try {
      let result = [];
      let item = this.item
      conditions.forEach(exp => {
        result.push(eval(exp.expression))
      })
      return result.indexOf(false);
    } catch (e) {
      console.error(e);
      return false;
    }

  }

  getClass(item, field) {
    let class_: string = "";
    if (field.class_conditions) {
      for (let val of field.class_conditions) {
        if (eval(val.expression)) {
          return val.class != undefined ? val.class : val.class_name ? val.class_name : '';
        }
      }
    }
    else if (field != undefined && field.name != undefined && (field.name == 'priority' || field.name == 'priority_name' || field.name == 'servicePriority')) {
      let priorityData = this.commonService?.servicePriorityList != undefined ? this.commonService?.servicePriorityList.find(x => (x.serviceType_code == item.serviceType_code) && (x.service_priority_id == (item.priority_code || item.priorityCode || item.priority || item.priority_id || item.servicePriorityCode))) : '';
      return priorityData != undefined && priorityData?.color_Id != undefined ? priorityData?.color_Id : '';
    }

    else if (field != undefined && field.type == 'TAT') {
      return this.setTatFlag(field, item, class_);
    }
    else if (field != undefined && field.type == 'STARTSTAGETAT') {
      return this.setStartStageTatFlag(field, item, class_);
    }
    // return ""
  }

  setTatFlag(field, item, class_) {
    if (item.tat != undefined) {
      let fromMatched = this.baseService.buildDyanamicStr(field.currentStage, { data: item });
      let toMatched = 'end_stage';
      for (let obj of item.tat) {
        if (obj[toMatched] === fromMatched) {
          let class_ = obj['critical_tat_expired'] != undefined && obj['critical_tat_expired'] ? 'grid-high-icon' : obj['warn_tat_expired'] != undefined && obj['warn_tat_expired'] ? 'grid-medium-icon' : '';
          return class_;
        }
      }
    }
  }

  setStartStageTatFlag(field, item, class_) {
    if (item.tat != undefined) {
      let fromMatched = this.baseService.buildDyanamicStr(field.currentStage, { data: item });
      let toMatched = 'start_stage';
      for (let obj of item.tat) {
        if (obj[toMatched] === fromMatched) {
          let class_ = obj['critical_tat_expired'] != undefined && obj['critical_tat_expired'] ? 'grid-high-icon' : obj['warn_tat_expired'] != undefined && obj['warn_tat_expired'] ? 'grid-medium-icon' : '';
          return class_;
        }
      }
    }
  }


  popupForm(action, val) {
    if (action.selector != undefined) {
      let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
      let obj = {
        data: {
          "selector": action.selector,
          "item": JSON.parse(JSON.stringify(val)),
          "action": action,
          "ehr_view_default": this.config && this.config.ehr_view_default ? this.config.ehr_view_default : false
        },
        title: action.popup.title,
        size: action.popup.size
      }
      if (action && action.title) {
        obj['title'] = action.title;
      }
      let path = this.router;
      this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => {
        this.baseService.reloadCurrentUrl()
      },
        err => { console.log("err"); });
    }
    let obj: any = Object.assign({ action }, { val });
    if (obj.action.form) {
      let size = this.baseService.getModalSize(action['popup'] && action['popup']['size'] ? action['popup']['size'] : 'lg');
      this.smartModalService.open(DynamicPopUpComponent, obj, obj.action.title, size).pipe(take(1)).subscribe(res => {
        if (res) {
          this.baseService.reloadCurrentUrl()
        }
      },
        err => {
          console.log("err");
        }
      );
    }
  }

  getStyle(buttonResource: any[] = []) {
    const length = buttonResource?.length || 0;
    let width = '33.33%';
    if (length === 1) width = '100%';
    else if (length === 2) width = '50%';
    this.wrapperStyle = {
      'border-radius': '10px',
      'font-size': '14px',
      'height': '36px',
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'box-shadow': '1px 1px 4px 1px #bababa',
      'width': width
    };
  }

  getButtonCount(buttonResource: any[]) {
    this.visibleButtons = (buttonResource || []).filter(btn =>
      btn.valid && this.checkConditionactionname(btn)
    );

    this.getStyle(this.visibleButtons); //  use filtered list
  }

  customRoute(action, key) {
    if (this.dialogRef)
      this.dialogRef.close();
    //this will work as new capability
    if (action.route_path != undefined && action.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(action.route_path, key);
    }
    else {
      //console.log("Key ", action, key);
      var app = '';
      if (action.hasOwnProperty('application')) {
        app = action.application;
      } else {
        app = this.appService.getApplication();
      }
      var keyForUrl = '';
      if (action.hasOwnProperty('get_key')) {
        keyForUrl = this.route.snapshot.queryParams.key;
      } else {
        if (action.set_key != undefined && action.set_key != '') {
          keyForUrl = key[action.set_key];
        } else {
          keyForUrl = key.id ? key.id : key;//change by saurav deep for getting key
        }
      }
      let queryParams = { key: keyForUrl };
      if (action.hasOwnProperty('query_params')) {
        let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
        queryParams = { ...queryParams, ...{ query_params } }
      }
      if (action.hasOwnProperty('queryParams')) {
        let banner = { banner: JSON.stringify(action.queryParams) }
        queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
      } else {
        let returnUrl = { returnUrl: this.router.url };
        queryParams = { ...queryParams, ...returnUrl }
      }
      console.log("query Params is ", queryParams);
      let url = '';
      if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
        if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
          url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else if (action.redirect.action == 'list') {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        }
      } else if (action.hasOwnProperty('redirectLink')) {
        action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
        url = '/' + app + '/' + action.redirectLink;
        if (action.hasOwnProperty('queryParams')) {
          this.router.navigate([url], {
            queryParams: queryParams
          });
        } else {
          this.router.navigate([url], { queryParams: queryParams });
        }
      }
    }
  }


}
